import React from 'react'

interface IconProps {
  className?: string
}

const Gantt02 = ({ className }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6 11C6 10.4477 6.44772 10 7 10H15C15.5523 10 16 10.4477 16 11V13C16 13.5523 15.5523 14 15 14H7C6.44772 14 6 13.5523 6 13V11Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M9 18C9 17.4477 9.44772 17 10 17H20C20.5523 17 21 17.4477 21 18V20C21 20.5523 20.5523 21 20 21H10C9.44772 21 9 20.5523 9 20V18Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M3 4C3 3.44772 3.44772 3 4 3H11C11.5523 3 12 3.44772 12 4V6C12 6.55228 11.5523 7 11 7H4C3.44772 7 3 6.55228 3 6V4Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
)

export default Gantt02
